import { render, staticRenderFns } from "./singUp.vue?vue&type=template&id=46ae6b6e&scoped=true&"
import script from "./singUp.vue?vue&type=script&lang=js&"
export * from "./singUp.vue?vue&type=script&lang=js&"
import style0 from "./singUp.vue?vue&type=style&index=0&id=46ae6b6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ae6b6e",
  null
  
)

export default component.exports